import type { ButtonHTMLAttributes } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement>;

const OutlinedButton = ({ className, ...others }: Props) => (
  <button
    {...others}
    className={`h-[45px] border-solid border border-[#131313] bg-white font-chivo-regular uppercase tracking-[1.3px] ${className}`}
  />
);

export default OutlinedButton;
